import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFire } from '@fortawesome/free-solid-svg-icons';

// Fixed colour rather than theme-driven so the pill stands out from the
// theme-coloured tenure/discount badges — same approach as the fixed red
// "Sold" badge in PropertyCard.
const HOT_BADGE_BACKGROUND_COLOUR = '#EA580C';

interface HotBadgeProps {
  /** Smaller pill padding to match ListView's tighter badge row. */
  compact?: boolean;
}

/**
 * "Hot" pill shown on owner-pinned hot properties (isHot on the list
 * response). Server pins hot rows first on page 1; this badge is the
 * visual marker across the grid, list and detail views.
 */
const HotBadge = ({ compact = false }: HotBadgeProps) => (
  <span
    className={`text-xs font-bold text-white rounded-md inline-flex items-center gap-1 ${
      compact ? 'py-0.5 px-1.5' : 'py-1 px-2'
    }`}
    style={{ background: HOT_BADGE_BACKGROUND_COLOUR, color: 'white' }}
  >
    <FontAwesomeIcon icon={faFire} />
    Hot
  </span>
);

export default HotBadge;
